/*
 *  Copyright (c) Pro3W 2024
 *  author: Sławomir Moskal
 *  project: dev.cms.pro3w.pl
 *  filename: js_body_end.js
 *  last update: 17.11.2024, 23:06
 */


//Dark mode
let mode = window.localStorage.getItem("mode"),
  root = document.getElementsByTagName("html")[0];
if (mode !== undefined && mode === "dark") {
  root.classList.add("dark-mode");
} else {
  root.classList.remove("dark-mode");
}

//function
(function () {
  "use strict";
  var t, e, r, a, n, o, l, c;
  null !== (e = document.querySelector('[data-bs-toggle="mode"]')) &&
  ((t = e.querySelector(".form-check-input")),
    "dark" === mode
      ? (root.classList.add("dark-mode"), (t.checked = !0))
      : (root.classList.remove("dark-mode"), (t.checked = !1)),
    e.addEventListener("click", function (e) {
      t.checked
        ? (root.classList.add("dark-mode"),
          window.localStorage.setItem("mode", "dark"))
        : (root.classList.remove("dark-mode"),
          window.localStorage.setItem("mode", "light"));
    }));
})();

//New cookie

// import "aos"; ta bibliotek apowoduje ponowne wczytanie jquery - do weryfikacji
import AOS from '@dartmoon/aos-responsive'

AOS.init({
  // You AOS configs
})
window.AOS = AOS;

// import imagesLoaded from 'imagesloaded';
// import Masonry from 'masonry-layout';
// import Isotope from 'isotope-layout';

import LazyLoad from "vanilla-lazyload";

window.LazyLoad = LazyLoad;
